import type { ReactNode } from "react"
import { ErrorBoundary as SentryErrorBoundary } from "@sentry/react"
import ErrorDisplay from "./ErrorDisplay"

type Props = {
  readonly children: ReactNode
}

export default function ErrorBoundary({ children }: Props) {
  return (
    <SentryErrorBoundary fallback={ErrorDisplay}>
      {children}
    </SentryErrorBoundary>
  )
}
